// Builds a download filename with an optional date-range suffix,
// e.g. withDateRange('user-usage-stats', 'csv', from, to) -> "user-usage-stats_2026-05-09_to_2026-06-09.csv".
export function withDateRange(base: string, ext: string, startDate?: Date, endDate?: Date): string {
  const iso = (d: Date) => d.toISOString().split('T')[0];
  const suffix = startDate && endDate ? `_${iso(startDate)}_to_${iso(endDate)}` : '';
  return `${base}${suffix}.${ext}`;
}
